import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { ChatNotifier } from '../notifiers/chat-notifier';
import { ChatState } from '../states/chat-state';

@Injectable({ providedIn: 'root' })
export class ChatProvider extends BaseProvider<ChatNotifier, ChatState> {
  constructor() {
    super(ChatNotifier);
  }
}
